const indexes = {
    mean: {
        work: 8.1,
        collaboration: 6.5,
        wellbeing: 6.9,
    },
    timeseries: [
        {
            datetime: "2023-06-05 00:00:00",
            wellbeing: 8.53,
            work: 2.006,
            overall: 3.92,
            collaboration: 2.18,
        },
        {
            datetime: "2023-06-06 00:00:00",
            work: 3.03,
            wellbeing: 8.32,
            collaboration: 2.58,
            overall: 4.412,
        },
        {
            datetime: "2023-06-07 00:00:00",
            work: 3.753,
            wellbeing: 8.306,
            overall: 4.744,
            collaboration: 2.67,
        },
        {
            datetime: "2023-06-08 00:00:00",
            wellbeing: 8.14,
            collaboration: 2.755,
            overall: 4.626,
            work: 3.531,
        },
        {
            datetime: "2023-06-09 00:00:00",
            overall: 4.741,
            work: 3.746,
            wellbeing: 8.146,
            collaboration: 2.828,
        },
        {
            datetime: "2023-06-10 00:00:00",
            collaboration: 2.828,
            work: 4.01,
            overall: 4.841,
            wellbeing: 8.1,
        },
        {
            datetime: "2023-06-11 00:00:00",
            work: 3.983,
            collaboration: 2.828,
            overall: 4.829,
            wellbeing: 8.1,
        },
        {
            datetime: "2023-06-12 00:00:00",
            overall: 4.846,
            collaboration: 3.026,
            wellbeing: 7.942,
            work: 3.997,
        },
        {
            datetime: "2023-06-13 00:00:00",
            wellbeing: 7.796,
            work: 4.134,
            collaboration: 3.076,
            overall: 4.878,
        },
        {
            datetime: "2023-06-14 00:00:00",
            overall: 4.812,
            work: 3.965,
            wellbeing: 7.664,
            collaboration: 3.232,
        },
        {
            datetime: "2023-06-15 00:00:00",
            wellbeing: 7.702,
            collaboration: 3.304,
            work: 4.183,
            overall: 4.937,
        },
        {
            datetime: "2023-06-16 00:00:00",
            wellbeing: 7.626,
            overall: 4.86,
            work: 4.118,
            collaboration: 3.208,
        },
        {
            datetime: "2023-06-17 00:00:00",
            wellbeing: 7.636,
            work: 4.043,
            overall: 4.831,
            collaboration: 3.208,
        },
        {
            datetime: "2023-06-18 00:00:00",
            work: 4.085,
            wellbeing: 7.636,
            collaboration: 3.217,
            overall: 4.851,
        },
        {
            datetime: "2023-06-19 00:00:00",
            wellbeing: 7.734,
            overall: 5.062,
            collaboration: 3.125,
            work: 4.572,
        },
        {
            datetime: "2023-06-20 00:00:00",
            overall: 5.075,
            collaboration: 3.027,
            work: 4.515,
            wellbeing: 7.966,
        },
        {
            datetime: "2023-06-21 00:00:00",
            collaboration: 2.981,
            work: 4.785,
            overall: 5.215,
            wellbeing: 8.096,
        },
        {
            datetime: "2023-06-22 00:00:00",
            overall: 5.198,
            work: 4.812,
            collaboration: 2.879,
            wellbeing: 8.096,
        },
        {
            datetime: "2023-06-23 00:00:00",
            overall: 5.157,
            work: 4.725,
            collaboration: 2.837,
            wellbeing: 8.124,
        },
        {
            datetime: "2023-06-24 00:00:00",
            wellbeing: 8.124,
            overall: 5.149,
            collaboration: 2.837,
            work: 4.709,
        },
        {
            datetime: "2023-06-25 00:00:00",
            wellbeing: 8.016,
            work: 4.692,
            collaboration: 2.837,
            overall: 5.111,
        },
        {
            datetime: "2023-06-26 00:00:00",
            wellbeing: 7.982,
            collaboration: 3.035,
            work: 4.324,
            overall: 5.001,
        },
        {
            datetime: "2023-06-27 00:00:00",
            work: 4.309,
            wellbeing: 7.762,
            overall: 4.973,
            collaboration: 3.179,
        },
        {
            datetime: "2023-06-28 00:00:00",
            wellbeing: 7.88,
            overall: 4.916,
            work: 4.046,
            collaboration: 3.257,
        },
        {
            datetime: "2023-06-29 00:00:00",
            work: 3.841,
            overall: 4.839,
            collaboration: 3.235,
            wellbeing: 7.942,
        },
        {
            datetime: "2023-06-30 00:00:00",
            overall: 4.847,
            work: 3.65,
            collaboration: 3.429,
            wellbeing: 8.062,
        },
        {
            datetime: "2023-07-01 00:00:00",
            work: 3.637,
            overall: 4.85,
            wellbeing: 8.062,
            collaboration: 3.458,
        },
        {
            datetime: "2023-07-02 00:00:00",
            wellbeing: 8.17,
            overall: 4.872,
            collaboration: 3.449,
            work: 3.622,
        },
        {
            datetime: "2023-07-03 00:00:00",
            work: 3.471,
            wellbeing: 8.12,
            overall: 4.808,
            collaboration: 3.501,
        },
        {
            datetime: "2023-07-04 00:00:00",
            wellbeing: 8.064,
            work: 3.297,
            overall: 4.75,
            collaboration: 3.617,
        },
        {
            datetime: "2023-07-05 00:00:00",
            overall: 4.641,
            collaboration: 3.633,
            wellbeing: 7.914,
            work: 3.132,
        },
        {
            datetime: "2023-07-06 00:00:00",
            collaboration: 3.953,
            wellbeing: 7.776,
            overall: 4.71,
            work: 3.17,
        },
        {
            datetime: "2023-07-07 00:00:00",
            work: 3.215,
            wellbeing: 7.67,
            collaboration: 3.949,
            overall: 4.698,
        },
        {
            datetime: "2023-07-08 00:00:00",
            overall: 4.701,
            collaboration: 3.92,
            work: 3.242,
            wellbeing: 7.67,
        },
        {
            datetime: "2023-07-09 00:00:00",
            overall: 4.705,
            work: 3.253,
            wellbeing: 7.67,
            collaboration: 3.92,
        },
        {
            datetime: "2023-07-10 00:00:00",
            wellbeing: 7.74,
            work: 3.354,
            collaboration: 3.958,
            overall: 4.779,
        },
        {
            datetime: "2023-07-11 00:00:00",
            work: 3.46,
            overall: 4.981,
            wellbeing: 7.52,
            collaboration: 4.977,
        },
        {
            datetime: "2023-07-12 00:00:00",
            wellbeing: 7.784,
            overall: 4.772,
            work: 3.274,
            collaboration: 4.008,
        },
        {
            datetime: "2023-07-13 00:00:00",
            wellbeing: 7.595,
            overall: 5.004,
            collaboration: 4.96,
            work: 3.474,
        },
        {
            datetime: "2023-07-14 00:00:00",
            work: 3.628,
            overall: 5.085,
            collaboration: 4.915,
            wellbeing: 7.664,
        },
        {
            datetime: "2023-07-15 00:00:00",
            overall: 5.085,
            collaboration: 4.915,
            work: 3.628,
            wellbeing: 7.664,
        },
        {
            datetime: "2023-07-16 00:00:00",
            wellbeing: 7.816,
            collaboration: 3.941,
            overall: 4.906,
            work: 3.611,
        },
        {
            datetime: "2023-07-17 00:00:00",
            collaboration: 4.716,
            overall: 5.035,
            wellbeing: 7.508,
            work: 3.72,
        },
        {
            datetime: "2023-07-18 00:00:00",
            work: 3.605,
            collaboration: 4.376,
            overall: 4.937,
            wellbeing: 7.655,
        },
        {
            datetime: "2023-07-19 00:00:00",
            overall: 4.873,
            work: 3.512,
            collaboration: 4.146,
            wellbeing: 7.786,
        },
        {
            datetime: "2023-07-20 00:00:00",
            overall: 4.581,
            work: 3.023,
            wellbeing: 7.92,
            collaboration: 3.746,
        },
        {
            datetime: "2023-07-21 00:00:00",
            overall: 4.477,
            collaboration: 3.481,
            work: 2.895,
            wellbeing: 8,
        },
        {
            datetime: "2023-07-22 00:00:00",
            collaboration: 3.481,
            wellbeing: 8,
            work: 2.844,
            overall: 4.453,
        },
        {
            datetime: "2023-07-23 00:00:00",
            work: 2.844,
            wellbeing: 8.292,
            overall: 4.381,
            collaboration: 2.776,
        },
        {
            datetime: "2023-07-24 00:00:00",
            collaboration: 2.786,
            overall: 4.428,
            wellbeing: 8.294,
            work: 2.945,
        },
        {
            datetime: "2023-07-25 00:00:00",
            work: 3.035,
            collaboration: 2.898,
            overall: 4.456,
            wellbeing: 8.146,
        },
        {
            datetime: "2023-07-26 00:00:00",
            wellbeing: 7.884,
            overall: 4.511,
            collaboration: 2.918,
            work: 3.325,
        },
        {
            datetime: "2023-07-27 00:00:00",
            overall: 4.623,
            wellbeing: 7.958,
            work: 3.452,
            collaboration: 3.046,
        },
        {
            datetime: "2023-07-28 00:00:00",
            work: 3.438,
            wellbeing: 7.932,
            collaboration: 3.228,
            overall: 4.662,
        },
        {
            datetime: "2023-07-29 00:00:00",
            overall: 4.674,
            work: 3.467,
            collaboration: 3.228,
            wellbeing: 7.932,
        },
        {
            datetime: "2023-07-30 00:00:00",
            collaboration: 3.228,
            overall: 4.683,
            wellbeing: 7.932,
            work: 3.488,
        },
        {
            datetime: "2023-07-31 00:00:00",
            work: 3.252,
            collaboration: 3.252,
            wellbeing: 7.936,
            overall: 4.59,
        },
        {
            datetime: "2023-08-01 00:00:00",
            overall: 4.601,
            wellbeing: 8.02,
            collaboration: 3.162,
            work: 3.282,
        },
        {
            datetime: "2023-08-02 00:00:00",
            work: 3.396,
            wellbeing: 8.116,
            overall: 4.68,
            collaboration: 3.172,
        },
        {
            datetime: "2023-08-03 00:00:00",
            overall: 4.664,
            collaboration: 3.11,
            wellbeing: 7.986,
            work: 3.487,
        },
        {
            datetime: "2023-08-04 00:00:00",
            work: 3.371,
            collaboration: 2.968,
            wellbeing: 7.948,
            overall: 4.563,
        },
        {
            datetime: "2023-08-05 00:00:00",
            overall: 4.557,
            collaboration: 2.968,
            work: 3.356,
            wellbeing: 7.948,
        },
        {
            datetime: "2023-08-06 00:00:00",
            collaboration: 2.968,
            overall: 4.542,
            wellbeing: 7.948,
            work: 3.322,
        },
        {
            datetime: "2023-08-07 00:00:00",
            overall: 4.677,
            wellbeing: 8.078,
            work: 3.638,
            collaboration: 2.836,
        },
        {
            datetime: "2023-08-08 00:00:00",
            overall: 4.723,
            wellbeing: 8.204,
            work: 3.664,
            collaboration: 2.832,
        },
        {
            datetime: "2023-08-09 00:00:00",
            wellbeing: 8.312,
            work: 3.428,
            collaboration: 2.57,
            overall: 4.578,
        },
        {
            datetime: "2023-08-10 00:00:00",
            wellbeing: 8.282,
            overall: 4.701,
            work: 3.788,
            collaboration: 2.49,
        },
        {
            datetime: "2023-08-11 00:00:00",
            wellbeing: 8.19,
            overall: 4.762,
            collaboration: 2.534,
            work: 3.963,
        },
        {
            datetime: "2023-08-12 00:00:00",
            wellbeing: 8.19,
            overall: 4.756,
            collaboration: 2.534,
            work: 3.949,
        },
        {
            datetime: "2023-08-13 00:00:00",
            overall: 4.822,
            collaboration: 2.534,
            work: 4.102,
            wellbeing: 8.19,
        },
        {
            datetime: "2023-08-14 00:00:00",
            overall: 4.591,
            wellbeing: 8.198,
            collaboration: 2.398,
            work: 3.649,
        },
        {
            datetime: "2023-08-15 00:00:00",
            wellbeing: 8.188,
            work: 3.393,
            collaboration: 2.266,
            overall: 4.441,
        },
        {
            datetime: "2023-08-16 00:00:00",
            wellbeing: 8.21,
            work: 3.339,
            collaboration: 2.458,
            overall: 4.479,
        },
        {
            datetime: "2023-08-17 00:00:00",
            collaboration: 2.57,
            wellbeing: 8.396,
            work: 2.885,
            overall: 4.369,
        },
        {
            datetime: "2023-08-18 00:00:00",
            work: 2.755,
            wellbeing: 8.386,
            collaboration: 2.796,
            overall: 4.375,
        },
        {
            datetime: "2023-08-19 00:00:00",
            work: 2.751,
            collaboration: 2.805,
            wellbeing: 8.386,
            overall: 4.376,
        },
        {
            datetime: "2023-08-20 00:00:00",
            work: 2.64,
            overall: 4.327,
            wellbeing: 8.382,
            collaboration: 2.805,
        },
        {
            datetime: "2023-08-21 00:00:00",
            collaboration: 3.155,
            wellbeing: 8.284,
            overall: 4.535,
            work: 2.956,
        },
        {
            datetime: "2023-08-22 00:00:00",
            work: 3.186,
            collaboration: 3.511,
            wellbeing: 8.208,
            overall: 4.713,
        },
        {
            datetime: "2023-08-23 00:00:00",
            overall: 4.779,
            collaboration: 3.713,
            wellbeing: 8.088,
            work: 3.285,
        },
        {
            datetime: "2023-08-24 00:00:00",
            wellbeing: 7.978,
            work: 3.411,
            overall: 4.869,
            collaboration: 3.947,
        },
        {
            datetime: "2023-08-25 00:00:00",
            wellbeing: 8.048,
            work: 3.431,
            collaboration: 3.917,
            overall: 4.889,
        },
        {
            datetime: "2023-08-26 00:00:00",
            wellbeing: 8.048,
            collaboration: 3.908,
            work: 3.407,
            overall: 4.876,
        },
        {
            datetime: "2023-08-27 00:00:00",
            overall: 4.866,
            wellbeing: 8.048,
            work: 3.383,
            collaboration: 3.908,
        },
        {
            datetime: "2023-08-28 00:00:00",
            work: 3.24,
            collaboration: 3.514,
            overall: 4.725,
            wellbeing: 8.164,
        },
        {
            datetime: "2023-08-29 00:00:00",
            work: 3.118,
            overall: 4.662,
            collaboration: 3.308,
            wellbeing: 8.334,
        },
        {
            datetime: "2023-08-30 00:00:00",
            wellbeing: 8.482,
            collaboration: 2.854,
            work: 2.918,
            overall: 4.489,
        },
        {
            datetime: "2023-08-31 00:00:00",
            wellbeing: 8.398,
            collaboration: 2.664,
            overall: 4.407,
            work: 2.909,
        },
        {
            datetime: "2023-09-01 00:00:00",
            overall: 4.363,
            wellbeing: 8.484,
            collaboration: 2.54,
            work: 2.832,
        },
        {
            datetime: "2023-09-02 00:00:00",
            wellbeing: 8.484,
            overall: 4.371,
            collaboration: 2.54,
            work: 2.85,
        },
        {
            datetime: "2023-09-03 00:00:00",
            collaboration: 2.54,
            work: 2.868,
            wellbeing: 8.484,
            overall: 4.379,
        },
        {
            datetime: "2023-09-04 00:00:00",
            collaboration: 2.662,
            work: 2.686,
            wellbeing: 8.508,
            overall: 4.342,
        },
        {
            datetime: "2023-09-05 00:00:00",
            work: 2.889,
            wellbeing: 8.286,
            collaboration: 2.936,
            overall: 4.444,
        },
        {
            datetime: "2023-09-06 00:00:00",
            wellbeing: 8.024,
            overall: 4.642,
            work: 3.249,
            collaboration: 3.352,
        },
        {
            datetime: "2023-09-07 00:00:00",
            collaboration: 3.42,
            wellbeing: 8.046,
            overall: 4.765,
            work: 3.474,
        },
        {
            datetime: "2023-09-08 00:00:00",
            overall: 4.641,
            work: 3.241,
            collaboration: 3.35,
            wellbeing: 8.032,
        },
        {
            datetime: "2023-09-09 00:00:00",
            collaboration: 3.35,
            wellbeing: 8.032,
            work: 3.272,
            overall: 4.654,
        },
        {
            datetime: "2023-09-10 00:00:00",
            wellbeing: 8.032,
            work: 3.237,
            overall: 4.639,
            collaboration: 3.35,
        },
        {
            datetime: "2023-09-11 00:00:00",
            collaboration: 3.41,
            wellbeing: 7.886,
            work: 3.058,
            overall: 4.538,
        },
        {
            datetime: "2023-09-12 00:00:00",
            wellbeing: 8.118,
            overall: 4.341,
            collaboration: 2.934,
            work: 2.761,
        },
        {
            datetime: "2023-09-13 00:00:00",
            overall: 4.21,
            wellbeing: 8.356,
            work: 2.434,
            collaboration: 2.728,
        },
        {
            datetime: "2023-09-14 00:00:00",
            collaboration: 2.43,
            wellbeing: 8.368,
            overall: 3.958,
            work: 2.036,
        },
        {
            datetime: "2023-09-15 00:00:00",
            work: 2.223,
            overall: 4.006,
            collaboration: 2.394,
            wellbeing: 8.292,
        },
        {
            datetime: "2023-09-16 00:00:00",
            work: 2.223,
            collaboration: 2.394,
            overall: 4.006,
            wellbeing: 8.292,
        },
        {
            datetime: "2023-09-17 00:00:00",
            overall: 4.006,
            wellbeing: 8.292,
            work: 2.223,
            collaboration: 2.394,
        },
        {
            datetime: "2023-09-18 00:00:00",
            overall: 4.229,
            collaboration: 2.66,
            wellbeing: 8.218,
            work: 2.616,
        },
        {
            datetime: "2023-09-19 00:00:00",
            work: 2.584,
            overall: 4.18,
            wellbeing: 8.028,
            collaboration: 2.726,
        },
        {
            datetime: "2023-09-20 00:00:00",
            overall: 4.228,
            work: 2.547,
            wellbeing: 7.99,
            collaboration: 2.99,
        },
        {
            datetime: "2023-09-21 00:00:00",
            collaboration: 3.364,
            work: 2.435,
            overall: 4.275,
            wellbeing: 7.946,
        },
        {
            datetime: "2023-09-22 00:00:00",
            overall: 4.528,
            work: 2.808,
            wellbeing: 7.924,
            collaboration: 3.712,
        },
        {
            datetime: "2023-09-23 00:00:00",
            work: 2.852,
            collaboration: 3.712,
            wellbeing: 7.924,
            overall: 4.547,
        },
        {
            datetime: "2023-09-24 00:00:00",
            work: 3.196,
            overall: 4.694,
            wellbeing: 7.924,
            collaboration: 3.712,
        },
        {
            datetime: "2023-09-25 00:00:00",
            work: 3.219,
            collaboration: 3.448,
            wellbeing: 8.024,
            overall: 4.657,
        },
        {
            datetime: "2023-09-26 00:00:00",
            overall: 4.909,
            wellbeing: 8.138,
            collaboration: 3.664,
            work: 3.587,
        },
        {
            datetime: "2023-09-27 00:00:00",
            overall: 5.027,
            work: 3.966,
            collaboration: 3.474,
            wellbeing: 8.174,
        },
        {
            datetime: "2023-09-28 00:00:00",
            work: 4.123,
            collaboration: 3.282,
            overall: 5.091,
            wellbeing: 8.354,
        },
        {
            datetime: "2023-09-29 00:00:00",
            work: 3.932,
            wellbeing: 8.376,
            collaboration: 3.052,
            overall: 4.95,
        },
        {
            datetime: "2023-09-30 00:00:00",
            overall: 4.924,
            wellbeing: 8.376,
            work: 3.871,
            collaboration: 3.052,
        },
        {
            datetime: "2023-10-01 00:00:00",
            collaboration: 3.052,
            work: 3.551,
            overall: 4.782,
            wellbeing: 8.36,
        },
        {
            datetime: "2023-10-02 00:00:00",
            work: 3.529,
            wellbeing: 8.382,
            overall: 4.795,
            collaboration: 3.108,
        },
        {
            datetime: "2023-10-03 00:00:00",
            wellbeing: 8.262,
            collaboration: 3.102,
            work: 3.603,
            overall: 4.791,
        },
        {
            datetime: "2023-10-04 00:00:00",
            wellbeing: 8.258,
            overall: 4.682,
            work: 3.476,
            collaboration: 2.916,
        },
        {
            datetime: "2023-10-05 00:00:00",
            wellbeing: 8.154,
            overall: 4.656,
            collaboration: 2.916,
            work: 3.484,
        },
        {
            datetime: "2023-10-06 00:00:00",
            wellbeing: 8.166,
            overall: 4.705,
            collaboration: 2.83,
            work: 3.648,
        },
        {
            datetime: "2023-10-07 00:00:00",
            overall: 4.714,
            work: 3.67,
            collaboration: 2.83,
            wellbeing: 8.166,
        },
        {
            datetime: "2023-10-08 00:00:00",
            collaboration: 2.83,
            wellbeing: 8.166,
            overall: 4.713,
            work: 3.668,
        },
        {
            datetime: "2023-10-09 00:00:00",
            work: 4.051,
            collaboration: 2.796,
            overall: 4.894,
            wellbeing: 8.258,
        },
        {
            datetime: "2023-10-10 00:00:00",
            work: 3.744,
            wellbeing: 8.374,
            collaboration: 2.71,
            overall: 4.771,
        },
        {
            datetime: "2023-10-11 00:00:00",
            collaboration: 3.12,
            wellbeing: 8.326,
            work: 3.554,
            overall: 4.793,
        },
        {
            datetime: "2023-10-12 00:00:00",
            overall: 4.802,
            work: 3.511,
            collaboration: 3.302,
            wellbeing: 8.24,
        },
        {
            datetime: "2023-10-13 00:00:00",
            overall: 4.77,
            work: 3.41,
            collaboration: 3.53,
            wellbeing: 8.052,
        },
        {
            datetime: "2023-10-14 00:00:00",
            overall: 4.753,
            collaboration: 3.53,
            work: 3.369,
            wellbeing: 8.052,
        },
        {
            datetime: "2023-10-15 00:00:00",
            work: 3.329,
            wellbeing: 8.052,
            collaboration: 3.53,
            overall: 4.735,
        },
        {
            datetime: "2023-10-16 00:00:00",
            collaboration: 3.666,
            work: 3.027,
            wellbeing: 7.942,
            overall: 4.614,
        },
        {
            datetime: "2023-10-17 00:00:00",
            overall: 4.765,
            work: 3.337,
            collaboration: 3.798,
            wellbeing: 7.874,
        },
        {
            datetime: "2023-10-18 00:00:00",
            collaboration: 3.86,
            work: 3.858,
            wellbeing: 7.74,
            overall: 4.967,
        },
        {
            datetime: "2023-10-19 00:00:00",
            overall: 5.106,
            work: 4.186,
            collaboration: 4.01,
            wellbeing: 7.584,
        },
        {
            datetime: "2023-10-20 00:00:00",
            work: 4.013,
            collaboration: 4.016,
            overall: 5.045,
            wellbeing: 7.622,
        },
        {
            datetime: "2023-10-21 00:00:00",
            overall: 5.054,
            collaboration: 4.032,
            wellbeing: 7.498,
            work: 4.107,
        },
        {
            datetime: "2023-10-22 00:00:00",
            work: 4.111,
            wellbeing: 7.498,
            overall: 5.061,
            collaboration: 4.05,
        },
        {
            datetime: "2023-10-23 00:00:00",
            collaboration: 3.964,
            overall: 4.926,
            wellbeing: 7.556,
            work: 3.815,
        },
        {
            datetime: "2023-10-24 00:00:00",
            overall: 4.917,
            collaboration: 4.112,
            work: 3.903,
            wellbeing: 7.244,
        },
        {
            datetime: "2023-10-25 00:00:00",
            overall: 4.876,
            collaboration: 4.224,
            wellbeing: 7.056,
            work: 3.859,
        },
        {
            datetime: "2023-10-26 00:00:00",
            work: 3.708,
            overall: 4.819,
            wellbeing: 7.182,
            collaboration: 4.124,
        },
        {
            datetime: "2023-10-27 00:00:00",
            overall: 5.053,
            wellbeing: 7.216,
            collaboration: 4.056,
            work: 4.277,
        },
        {
            datetime: "2023-10-28 00:00:00",
            work: 4.295,
            collaboration: 4.039,
            overall: 5.091,
            wellbeing: 7.338,
        },
        {
            datetime: "2023-10-29 00:00:00",
            wellbeing: 7.338,
            work: 4.403,
            overall: 5.133,
            collaboration: 4.022,
        },
        {
            datetime: "2023-10-30 00:00:00",
            wellbeing: 7.398,
            work: 4.86,
            collaboration: 3.664,
            overall: 5.243,
        },
        {
            datetime: "2023-10-31 00:00:00",
            work: 4.542,
            overall: 5.138,
            collaboration: 3.378,
            wellbeing: 7.792,
        },
        {
            datetime: "2023-11-01 00:00:00",
            work: 4.326,
            wellbeing: 8.212,
            overall: 5.124,
            collaboration: 3.232,
        },
        {
            datetime: "2023-11-02 00:00:00",
            overall: 5.153,
            collaboration: 3.142,
            work: 4.468,
            wellbeing: 8.194,
        },
        {
            datetime: "2023-11-03 00:00:00",
            wellbeing: 8.064,
            collaboration: 3.308,
            overall: 5.051,
            work: 4.205,
        },
        {
            datetime: "2023-11-04 00:00:00",
            collaboration: 3.308,
            overall: 5.062,
            work: 4.23,
            wellbeing: 8.064,
        },
        {
            datetime: "2023-11-05 00:00:00",
            overall: 5.038,
            wellbeing: 8.07,
            collaboration: 3.308,
            work: 4.17,
        },
        {
            datetime: "2023-11-06 00:00:00",
            work: 3.934,
            overall: 4.929,
            collaboration: 3.46,
            wellbeing: 7.892,
        },
        {
            datetime: "2023-11-07 00:00:00",
            work: 3.934,
            collaboration: 3.574,
            overall: 4.953,
            wellbeing: 7.862,
        },
        {
            datetime: "2023-11-08 00:00:00",
            wellbeing: 7.542,
            collaboration: 3.666,
            work: 4.126,
            overall: 4.97,
        },
        {
            datetime: "2023-11-09 00:00:00",
            collaboration: 3.774,
            work: 4.006,
            wellbeing: 7.562,
            overall: 4.955,
        },
        {
            datetime: "2023-11-10 00:00:00",
            wellbeing: 7.56,
            overall: 4.953,
            work: 4.029,
            collaboration: 3.732,
        },
        {
            datetime: "2023-11-11 00:00:00",
            overall: 4.878,
            collaboration: 3.782,
            wellbeing: 7.452,
            work: 3.894,
        },
        {
            datetime: "2023-11-12 00:00:00",
            wellbeing: 7.324,
            collaboration: 3.809,
            overall: 4.774,
            work: 3.718,
        },
        {
            datetime: "2023-11-13 00:00:00",
            overall: 4.802,
            collaboration: 4.155,
            work: 3.608,
            wellbeing: 7.24,
        },
        {
            datetime: "2023-11-14 00:00:00",
            overall: 4.73,
            work: 3.502,
            wellbeing: 7.096,
            collaboration: 4.205,
        },
        {
            datetime: "2023-11-15 00:00:00",
            overall: 4.675,
            collaboration: 4.133,
            work: 3.377,
            wellbeing: 7.166,
        },
        {
            datetime: "2023-11-16 00:00:00",
            overall: 4.637,
            collaboration: 3.973,
            work: 3.309,
            wellbeing: 7.294,
        },
        {
            datetime: "2023-11-17 00:00:00",
            work: 3.146,
            collaboration: 3.865,
            overall: 4.581,
            wellbeing: 7.45,
        },
        {
            datetime: "2023-11-18 00:00:00",
            overall: 5.087,
            wellbeing: 7.257,
            collaboration: 4.802,
            work: 3.831,
        },
        {
            datetime: "2023-11-19 00:00:00",
            work: 3.728,
            overall: 5.079,
            collaboration: 4.768,
            wellbeing: 7.417,
        },
        {
            datetime: "2023-11-20 00:00:00",
            overall: 4.498,
            wellbeing: 7.868,
            collaboration: 3.821,
            work: 2.702,
        },
        {
            datetime: "2023-11-21 00:00:00",
            overall: 4.422,
            work: 2.592,
            collaboration: 3.479,
            wellbeing: 8.112,
        },
        {
            datetime: "2023-11-22 00:00:00",
            overall: 4.231,
            work: 2.13,
            collaboration: 3.245,
            wellbeing: 8.368,
        },
        {
            datetime: "2023-11-23 00:00:00",
            overall: 4.367,
            wellbeing: 8.262,
            work: 2.418,
            collaboration: 3.397,
        },
        {
            datetime: "2023-11-24 00:00:00",
            overall: 4.404,
            work: 2.45,
            wellbeing: 8.258,
            collaboration: 3.481,
        },
        {
            datetime: "2023-11-25 00:00:00",
            work: 2.571,
            overall: 4.455,
            collaboration: 3.482,
            wellbeing: 8.254,
        },
        {
            datetime: "2023-11-26 00:00:00",
            collaboration: 3.571,
            overall: 4.503,
            wellbeing: 8.058,
            work: 2.756,
        },
        {
            datetime: "2023-11-27 00:00:00",
            collaboration: 3.489,
            work: 2.495,
            wellbeing: 8.082,
            overall: 4.375,
        },
        {
            datetime: "2023-11-28 00:00:00",
            work: 2.541,
            overall: 4.49,
            collaboration: 4.01,
            wellbeing: 7.894,
        },
        {
            datetime: "2023-11-29 00:00:00",
            collaboration: 4.208,
            work: 2.683,
            overall: 4.591,
            wellbeing: 7.838,
        },
        {
            datetime: "2023-11-30 00:00:00",
            collaboration: 4.254,
            overall: 4.539,
            work: 2.545,
            wellbeing: 7.814,
        },
        {
            datetime: "2023-12-01 00:00:00",
            collaboration: 4.304,
            wellbeing: 7.82,
            overall: 4.579,
            work: 2.603,
        },
        {
            datetime: "2023-12-02 00:00:00",
            collaboration: 5.344,
            overall: 5.066,
            wellbeing: 7.587,
            work: 3.201,
        },
        {
            datetime: "2023-12-03 00:00:00",
            wellbeing: 7.825,
            collaboration: 5.319,
            overall: 5.034,
            work: 2.984,
        },
        {
            datetime: "2023-12-04 00:00:00",
            work: 2.73,
            wellbeing: 7.898,
            collaboration: 4.295,
            overall: 4.653,
        },
        {
            datetime: "2023-12-05 00:00:00",
            overall: 4.475,
            collaboration: 4.001,
            wellbeing: 7.972,
            work: 2.459,
        },
        {
            datetime: "2023-12-06 00:00:00",
            overall: 4.334,
            work: 2.214,
            wellbeing: 8.038,
            collaboration: 3.811,
        },
    ],
};

const getOverview = () => {
    return indexes;
};

export default getOverview;
